import { html } from 'htm/preact';
import { render } from 'preact';

import './utils/sentryActivation';

import Activation from './components/activation';

const deviceDataEl = document.querySelector('[data-devices-json]');
const devices = JSON.parse(deviceDataEl.innerHTML);

const params = new URLSearchParams(window.location.search);

const activationWrapper = document.getElementById('activation');
if (activationWrapper) {
  render(
    html`<${Activation}
      devices=${devices}
      activationCode=${params.get('code')}
      instantActivation=${params.get('instant') === 'true'}
    />`,
    activationWrapper,
  );
}
